export const HERO = {
  TITLE_A: "We build worlds",
  TITLE_B: "worth exploring",
  BODY: "mutopi is an independent game studio crafting real-life adventures that blur the line between game and world.",
  PRIMARY_CTA: "Explore our games",
  SECONDARY_CTA: "Join our community",
}
